import { render, staticRenderFns } from "./ScoreViewer.vue?vue&type=template&id=1cdc6c35&scoped=true"
import script from "./ScoreViewer.vue?vue&type=script&lang=js"
export * from "./ScoreViewer.vue?vue&type=script&lang=js"
import style0 from "./ScoreViewer.vue?vue&type=style&index=0&id=1cdc6c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc6c35",
  null
  
)

export default component.exports